export const api = {
  vehicle: {
    getRecordList: '/bas/vehicleBarrier/queryVehicleBarrierTrafficRecordList.json', // 获取员工通行记录列表
  }
}